import React from "react";
import ExcerciseTopImage from "@assets/images/ExerciseDetail.png";
import BackImg from "@assets/images/stepsBack.jpg";
const ExerciseDetailsHeader = () => {
  return (
    <div className="bg-cover text-white relative rounded-[12px] p-5 mt-[25%] sm:mt-[15%] md:mt-0 lg:mt-[7%] xl:mt-[10%]"
     style={{ backgroundImage: `url(${BackImg})` }}
    >
      <img
        src={ExcerciseTopImage}
        alt="ExeciseImageMobile"
        className="absolute top-[-25%] left-1/2 -translate-x-1/2 h-full w-full max-w-[300px] max-h-[200px] block md:hidden"
      />

      <div className="w-[100%] md:w-[50%] xl:w-[60%] mt-[110px] md:mt-0">
        <h1 className="tet-[20px] text-white font-[600] font-[Lato] mb-2">
          Your Personalized Workout Plan
        </h1>
        <h2 className="text-[18px] font-[Lato] font-[400] mb-1">
          Your Personal Guide To Better Health
        </h2>
        <p className="text-[14px] font-[Lato]">
          Achieve your fitness goals with workouts tailored to your body,
          lifestyle, and preferences. Whether you're a beginner or advanced, get
          routines designed just for you—with guided exercises, progress
          tracking, and expert tips to keep you motivated every step of the way.
        </p>
      </div>
      <img
        src={ExcerciseTopImage}
        alt="ExeciseImageDesktop"
        className="absolute right-0 bottom-[-3%] max-w-[50%] xl:max-w-[40%] lg:min-h-[270px] hidden md:block"
      />
    </div>
  );
};

export default ExerciseDetailsHeader;
